module.exports = __webpack_public_path__ + "media/src/images/certificates/certificate_ects_frame-2877249be4fc862e88739a01b086cc59.png";